/**
 * Shared styles for Utility Profit admin pages
 */

// Common form input styling
export const inputStyle = {
  height: '40px',
  width: '100%',
  padding: '0 10px',
  borderRadius: '8px',
  border: '1px solid #E5E5E5',
  fontFamily: 'greycliff',
  fontSize: '14px',
};

// Button styling for action buttons in tables
export const actionButtonStyle = {
  display: 'inline-block',
  padding: '6px 12px',
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: '500',
  fontFamily: 'greycliff',
  borderRadius: '4px',
  textAlign: 'center',
  userSelect: 'none',
};

// Primary action button (edit)
export const editButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#f0f8ff',
  color: '#0066cc',
  border: '1px solid #e0e0e0',
};

// Danger action button (delete)
export const deleteButtonStyle = {
  ...actionButtonStyle,
  backgroundColor: '#fff0f0',
  color: '#cc0000',
  border: '1px solid #ffcccc',
};

// Add new button styling
export const addNewButtonStyle = {
  display: 'inline-block',
  padding: '10px 16px',
  cursor: 'pointer',
  backgroundColor: '#ffcf30',
  border: '1px solid #f5b800',
  borderRadius: '8px',
  color: '#333',
  fontSize: '14px',
  fontWeight: '500',
  fontFamily: 'greycliff',
  boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
};

// Pagination link styling
export const paginationLinkStyle = {
  display: 'inline-block',
  margin: '0 3px',
  padding: '4px 8px',
  cursor: 'pointer',
  fontSize: '13px',
  fontFamily: 'greycliff',
  userSelect: 'none',
};

// Active pagination link
export const activePaginationLinkStyle = {
  ...paginationLinkStyle,
  backgroundColor: '#ffcf30',
  borderRadius: '3px',
  fontWeight: '600',
  color: '#333',
};

// Disabled pagination link
export const disabledPaginationLinkStyle = {
  ...paginationLinkStyle,
  cursor: 'default',
  color: '#999',
  opacity: 0.7,
};

// Modal button styling
export const modalButtonStyle = {
  display: 'block',
  width: '100%',
  padding: '10px',
  textAlign: 'center',
  borderRadius: '8px',
  fontSize: '14px',
  cursor: 'pointer',
  fontFamily: 'greycliff',
};

// Primary modal button
export const primaryModalButtonStyle = {
  ...modalButtonStyle,
  backgroundColor: '#ffcf30',
  border: '1px solid #f5b800',
  color: '#333',
  fontWeight: '600',
};

// Secondary modal button
export const secondaryModalButtonStyle = {
  ...modalButtonStyle,
  backgroundColor: '#f5f5f5',
  border: '1px solid #e0e0e0',
  color: '#333',
  fontWeight: '400',
};
